/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { useState } from 'react';
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getProjectRestoreUrl } from './utils.tsx';

type Props = {
	projectId: number | string;
};

type ProjectRestoreMethodProps = {
	onSuccess: () => void;
	onFailure: (arg1: Error) => void;
};

export const useProjectRestoreService = ({
	projectId,
}: Props): [boolean, (arg1: ProjectRestoreMethodProps) => void] => {
	const [loading, setLoading] = useState<boolean>(false);

	const restoreProject = ({ onSuccess, onFailure }: ProjectRestoreMethodProps) => {
		const url = getProjectRestoreUrl(projectId);
		setLoading(true);

		performPostRequest(url)
			.then(() => {
				setLoading(false);
				onSuccess();
			})
			.catch((error) => {
				if (!(error.statusCode === 409)) {
					fireErrorAnalytics({
						meta: {
							id: 'useProjectRestoreService',
							packageName: 'jiraProjectRestoreModal',
						},
						error,
						attributes: {
							projectId,
							errorStatusCode: error.statusCode,
						},
					});
				}
				setLoading(false);
				onFailure(error);
			});
	};
	return [loading, restoreProject];
};
